import { html, PropertyValues, TemplateResult } from 'lit';
import {
  API_TYPE_NIRVANA,
  WEB_COMPONENT_EXECUTIVE_SUMMARY_THREATS_BREAKDOWN,
} from '../../../../webcomponents.constants';
import { GzGenericWidgetContent } from '../../../../genericDashboard/gzGenericWidget';
import { customElement, property, query } from 'lit/decorators.js';
import { GetWidgetDataRequest } from '../../../../types/widget/types';
import { Observable, of } from 'rxjs';
import {
  GetThreatsBreakdownResponse,
  ThreatsBreakdownPayload,
} from '@nirvana/shared/dtos/types/widgets/common';
import { translateFn } from '../../../../utils/translator.helper';
import { getTimezone } from '../../../../utils/global.utils';
import { ThreatsBreakdownWebComponent } from '../../../../threatsBreakdown';
import { getDisplayMode, sanitizeReportingPeriod } from '../../../utils/utils';

@customElement(WEB_COMPONENT_EXECUTIVE_SUMMARY_THREATS_BREAKDOWN)
export class GzThreatsBreakdownWebComponent extends GzGenericWidgetContent {
  @property({ type: Object, attribute: true, reflect: true })
  payload: ThreatsBreakdownPayload;

  @query('#gzThreatsBreakdown')
  private threatsBreakdown: ThreatsBreakdownWebComponent;

  injectDependencies(dependencies: any) {
    this.dependencies = dependencies;
  }

  getPayload() {
    return this.payload;
  }

  updated(_changedProperties: PropertyValues): void {
    super.updated(_changedProperties);

    const dependencies = {
      Ext: this.dependencies ? this.dependencies.Ext : undefined,
      getTimezone: getTimezone,
      getUserLanguage: Application.Main.getLanguage,
      translateFn: translateFn,
      api: {
        type: API_TYPE_NIRVANA,
        clients: {
          Widgets: {
            getThreatsBreakdown: function (request: GetWidgetDataRequest): Observable<GetThreatsBreakdownResponse> {
              return of(this.getPayload().threatsBreakdown);
            }.bind(this)
          }
        }
      }
    };

    if (this.threatsBreakdown) {
      if (!this.threatsBreakdown.started) {
        this.threatsBreakdown.injectDependencies(dependencies);
        this.threatsBreakdown.start();
      } else {
        this.threatsBreakdown.controller?.render();
      }
    }
  }

  protected renderContent(): TemplateResult {
    return html `
      <gz-threats-breakdown id="gzThreatsBreakdown"
                            data-reporting-period=${JSON.stringify(sanitizeReportingPeriod(this.payload?.reportingPeriod))}
                            data-targets=${JSON.stringify(this.payload?.targets)}
                            data-can-drill-down=${true}
                            data-display-mode=${getDisplayMode()}
      ></gz-threats-breakdown>`;
  }
}
